module.exports = __webpack_public_path__ + "img/alex4.e2ed2ade.png";